<template>
  <v-layout column>
    <v-toolbar dense flat style="background: none" class="authors">
      <v-toolbar-title class="pl-1 body-1">{{ label }}</v-toolbar-title>
      <v-dialog
          v-model="dialog"
          persistent
          scrollable
          width="650"
      >
        <v-btn flat icon color="primary" slot="activator"
               @click="()=>{ editIdx=null; Object.assign(item,freshItem); user={name:''}; }">
          <v-icon>add</v-icon>
        </v-btn>
        <v-card>
          <v-card-text>
            <v-form v-model="formValid" ref="formRef">
              <v-container>
                <v-layout row wrap>

                  <v-flex xs8>
                    <x-user-select-form
                        label="获奖人姓名"
                        v-model="user"
                        :rules="rules.required"
                    />
                  </v-flex>

                  <v-flex xs4>
                    <v-select
                        label="获奖人排名"
                        :items="validRanks"
                        v-model="item.rank"
                        :rules="rules.required"
                    />
                  </v-flex>

                  <v-flex xs4>
                    <v-text-field
                        label="获奖人证书编号"
                        v-model="item.certificateNo"
                    />
                  </v-flex>

                  <v-flex xs8>
                    <v-text-field
                        label="获奖人单位"
                        v-model="item.deptName"
                        :rules="rules.required"
                        :disabled="item.userId && item.userId.length > 0"
                    />
                  </v-flex>

                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="dialog = false">取消</v-btn>
            <v-btn color="primary" @click.native="onOk">确定</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <v-data-table
        class="dense"
        :headers="headers"
        :items="value"
        hide-actions
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.rank }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.certificateNo }}</td>
        <td>{{ props.item.deptName }}</td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="onEdit(props.index, props.item)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <span>编辑</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="onDel(props.index)">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
            <span>删除</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
  </v-layout>
</template>
<script>
import XUserSelectForm from '@/components/global/UserSelectForm'

// const userURI = '/api/syst/user/';

export default {
  name: 'awardAwardees',
  props: ['value', 'label', 'hint'],
  components: {XUserSelectForm},

  data() {
    return {
      headers: [
        {text: '排序', sortable: false, value: 'rank', width: 18},
        {text: '姓名', sortable: false, value: 'name'},
        {text: '证书编号', sortable: false, value: 'certificateNo'},
        {text: '单位', sortable: false, value: 'rank'},
        {text: '操作', sortable: false, value: 'dbid'}
      ],

      dialog: false,
      freshItem: {
        userId: null,
        name: null,
        rank: null,
        deptName: null,
        certificateNo: null,
      },
      item: {},

      editIdx: null,

      user: {
        userId: null,
        name: null,
        deptName: null,
      },

      formValid: false,

      rankItems: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40],

      rules: {
        required: [
          v => !!v || '该项必填'
        ]
      }
    }
  },
  watch: {
    user: function (u) {
      Object.assign(this.item, u);
    }
  },

  computed: {
    validRanks() {
      if (this.value) {
        const rr = this.value.map(v => v.rank);
        return this.rankItems.filter(v => !rr.includes(v));
      }
      return this.rankItems;
    }
  },

  methods: {
    onEdit(idx, it) {
      this.editIdx = idx;
      this.item = window.xutil.clone(it);
      this.user.userId = this.item.userId;
      this.user.name = this.item.name;
      this.user.deptName = this.item.deptName;

      this.dialog = true;
    },
    onOk() {
      if (this.$refs.formRef.validate()) {
        let awardees = window.xutil.clone(this.value);

        if (this.editIdx != null) {
          awardees[this.editIdx] = window.xutil.clone(this.item);
        } else {
          awardees.push(window.xutil.clone(this.item));
        }

        awardees.sort((a, b) => a.rank - b.rank);
        this.$emit('input', awardees);
        this.dialog = false;
      }
    },

    onDel(idx) {
      this.$emit('input', this.value.filter((v, i) => i !== idx))
    }
  }

}
</script>
<style>
.authors.v-toolbar > .v-toolbar__content {
  padding-left: 0;
}
</style>

